import { defineComponent as v, ref as d, useSlots as D, computed as h, watch as w, openBlock as E, createElementBlock as _, renderSlot as r, createCommentVNode as s } from "vue";
import { DEFAULT_BREAKPOINTS as T } from "./constant/breakpoints.js";
import { UPDATE_MODEL_VALUE as l } from "./constant/events.js";
import "x-utils";
import "@vueuse/core";
import "lodash-es";
import "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import { useElementBreakpoint as B } from "./hooks/useElementBreakpoint.js";
import { useBreakpoint as y } from "./hooks/useBreakpoint.js";
const j = /* @__PURE__ */ v({
  name: "e-responsive",
  __name: "responsive",
  props: {
    modelValue: {},
    elementDetection: {},
    breakpoints: { default: () => T }
  },
  emits: [l],
  setup(a, { emit: c }) {
    const t = a, u = c, i = d(), k = D(), { breakpoint: n, isTablet: m, isMobile: f, isDesktop: b } = t.elementDetection ? B(i, t.elementDetection, t.breakpoints) : y(), o = h(() => {
      const e = f.value || m.value && !k.tablet, p = m.value && !e;
      return {
        showMobile: e,
        showTablet: p,
        showDesktop: b.value
      };
    });
    return w(n, () => {
      u(l, n.value);
    }, { immediate: !0 }), (e, p) => (E(), _("div", {
      ref_key: "containerRef",
      ref: i,
      class: "e-responsive"
    }, [
      o.value.showMobile ? r(e.$slots, "mobile", { key: 0 }) : s("", !0),
      o.value.showTablet ? r(e.$slots, "tablet", { key: 1 }) : s("", !0),
      o.value.showDesktop ? r(e.$slots, "desktop", { key: 2 }) : s("", !0)
    ], 512));
  }
});
export {
  j as default
};
//# sourceMappingURL=responsive.js.map
